import "./SecurityPipeline.css";

export default function SecurityPipeline() {
  return (
    <div id="security-pipeline" className="outsourcemainclass">
      <h2 className="heading">DevOps Security & Compliance Services</h2>
      <p className="subheading">
        Protect applications and infrastructure with BastionEx’s DevOps Security
        & Compliance services, embedding security and compliance into every
        DevOps stage without slowing delivery or compromising regulatory
        standards.
      </p>
      <button className="btn1">Let's Discuss Your Project</button>
    </div>
  );
}
